import { createAction, props } from '@ngrx/store';
import { IGenericError, ErrorResponse } from '../../../core/models/generic-models';
import { IResendOTPRequest, IResendOtpRequest, IResendOTPResponse, IResendOtpResponse } from '../../../core/models/otp-resend.model';

export const loadResendOtpRequest = createAction('[ResendOtp] Load ResendOtps Request', props<{ request: IResendOtpRequest }>());

export const loadResendOtpsSuccess = createAction('[ResendOtp] Load ResendOtps Success', props<{ response: IResendOtpResponse }>());

export const loadResendOtpsFailure = createAction('[ResendOtp] Load ResendOtps Failure', props<{ error: IGenericError<ErrorResponse> }>());

export const clearResendOtpsSuccess = createAction('[ResendOtp] Clear ResendOtps Success');


export const resendOtpRequest = createAction('[ResendOtp] Load ResendOtp Request', props<{ request: IResendOTPRequest }>());

export const resendOtpSuccess = createAction('[ResendOtp] Load ResendOtp Success', props<{ response: IResendOTPResponse }>());

export const resendOtpFailure = createAction('[ResendOtp] Load ResendOtp Failure', props<{ error: IGenericError<ErrorResponse> }>());

export const clearResendOtpSuccess = createAction('[ResendOtp] Clear ResendOtp Success');
